import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Card, Grid, Avatar, FormControl, InputLabel, Select, MenuItem, TextField, Button } from '@mui/material';
import { motion } from 'framer-motion';
import axios from 'axios';
import Calendar from 'react-calendar'; // Import Calendar
import 'react-calendar/dist/Calendar.css'; // Import Calendar styles
import '../css/Zodiak.css'; // Import CSS untuk styling

// Import gambar zodiak dari direktori lokal
import ariesImage from '../images/aries.png';
import taurusImage from '../images/taurus.png';
import geminiImage from '../images/gemini.png';
import cancerImage from '../images/cancer.png';
import leoImage from '../images/leo.png';
import virgoImage from '../images/virgo.png';
import libraImage from '../images/libra.png';
import scorpioImage from '../images/scorpio.png';
import sagittariusImage from '../images/sagitarius.png';
import capricornImage from '../images/capricon.png';
import aquariusImage from '../images/aquarius.png';
import piscesImage from '../images/pisces.png';





// Import gambar tarot
import foolImage from '../images/card/the_fool.png';
import magicianImage from '../images/card/The_Magician.png';
import highPriestessImage from '../images/card/The_High_Priestess.png';
import empressImage from '../images/card/The_Empress.png';
import emperorImage from '../images/card/The_Emperor.png';
import hierophantImage from '../images/card/The_Hierophant.png';
import loversImage from '../images/card/The_Lovers.png';
import chariotImage from '../images/card/The_Chariot.png';
import strengthImage from '../images/card/Strength.png';
import hermitImage from '../images/card/The_Hermit.png';
import wheelOfFortuneImage from '../images/card/Wheel_of_Fortune.png';
import justiceImage from '../images/card/Justice.png';
import hangedManImage from '../images/card/The_Hanged_Man.png';
import deathImage from '../images/card/Death.png';
import temperanceImage from '../images/card/Temperance.png';
import devilImage from '../images/card/The_Devil.png';
import towerImage from '../images/card/The_Tower.png';
import starImage from '../images/card/The_Star.png';
import moonImage from '../images/card/The_Moon.png';
import sunImage from '../images/card/The_Sun.png';
import judgementImage from '../images/card/The_Last_Judgment.png';
import worldImage from '../images/card/The_World.png';

// Import gambar kartu minor arcana
import twoOfCupsImage from '../images/card/Two_of_Cups.png';
import threeOfCupsImage from '../images/card/Three_of_Cups.png';
import fourOfCupsImage from '../images/card/Four_of_Cups.png';
import fiveOfCupsImage from '../images/card/Five_of_Cups.png';
import sixOfCupsImage from '../images/card/Six_of_Cups.png';
import sevenOfCupsImage from '../images/card/Seven_of_Cups.png';
import eightOfCupsImage from '../images/card/Eight_of_Cups.png';
import nineOfCupsImage from '../images/card/Nine_of_Cups.png';
import tenOfCupsImage from '../images/card/Ten_of_Cups.png';
import aceOfCupsImage from '../images/card/Ace_of_Cups.png';
import kingOfCupsImage from '../images/card/King_of_Cups.png';
import knightOfCupsImage from '../images/card/Knight_of_Cups.png';
import pageOfCupsImage from '../images/card/Page_of_Cups.png';
import queenOfCupsImage from '../images/card/Queen_of_Cups.png';

import twoOfPentaclesImage from '../images/card/Two_of_Pentacles.png';
import threeOfPentaclesImage from '../images/card/Three_of_Pentacles.png';
import fourOfPentaclesImage from '../images/card/Four_of_Pentacles.png';
import fiveOfPentaclesImage from '../images/card/Five_of_Pentacles.png';
import sixOfPentaclesImage from '../images/card/Six_of_Pentacles.png';
import sevenOfPentaclesImage from '../images/card/Seven_of_Pentacles.png';
import eightOfPentaclesImage from '../images/card/Eight_of_Pentacles.png';
import nineOfPentaclesImage from '../images/card/Nine_of_Pentacles.png';
import tenOfPentaclesImage from '../images/card/Ten_of_Pentacles.png';
import aceOfPentaclesImage from '../images/card/Ace_of_Pentacles.png';
import kingOfPentaclesImage from '../images/card/King_of_Pentacles.png';
import knightOfPentaclesImage from '../images/card/Knight_of_Pentacles.png';
import pageOfPentaclesImage from '../images/card/Page_of_Pentacles.png';
import queenOfPentaclesImage from '../images/card/Queen_of_Pentacles.png';

import twoOfSwordsImage from '../images/card/Two_of_Swords.png';
import threeOfSwordsImage from '../images/card/Three_of_Swords.png';
import fourOfSwordsImage from '../images/card/Four_of_Swords.png';
import fiveOfSwordsImage from '../images/card/Five_of_Swords.png';
import sixOfSwordsImage from '../images/card/Six_of_Swords.png';
import sevenOfSwordsImage from '../images/card/Seven_of_Swords.png';
import eightOfSwordsImage from '../images/card/Eight_of_Swords.png';
import nineOfSwordsImage from '../images/card/Nine_of_Swords.png';
import tenOfSwordsImage from '../images/card/Ten_of_Swords.png';
import aceOfSwordsImage from '../images/card/Ace_of_Swords.png';
import kingOfSwordsImage from '../images/card/King_of_Swords.png';
import knightOfSwordsImage from '../images/card/Knight_of_Swords.png';
import pageOfSwordsImage from '../images/card/Page_of_Swords.png';
import queenOfSwordsImage from '../images/card/Queen_of_Swords.png';

import twoOfWandsImage from '../images/card/Two_of_Wands.png';
import threeOfWandsImage from '../images/card/Three_of_Wands.png';
import fourOfWandsImage from '../images/card/Four_of_Wands.png';
import fiveOfWandsImage from '../images/card/Five_of_Wands.png';
import sixOfWandsImage from '../images/card/Six_of_Wands.png';
import sevenOfWandsImage from '../images/card/Seven_of_Wands.png';
import eightOfWandsImage from '../images/card/Eight_of_Wands.png';
import nineOfWandsImage from '../images/card/Nine_of_Wands.png';
import tenOfWandsImage from '../images/card/Ten_of_Wands.png';
import aceOfWandsImage from '../images/card/Ace_of_Wands.png';
import kingOfWandsImage from '../images/card/King_of_Wands.png';
import knightOfWandsImage from '../images/card/Knight_of_Wands.png';
import pageOfWandsImage from '../images/card/Page_of_Wands.png';
import queenOfWandsImage from '../images/card/Queen_of_Wands.png';

// Mapping kartu tarot ke gambar
const tarotImages = {
  "The Fool": foolImage,
  "The Magician": magicianImage,
  "The High Priestess": highPriestessImage,
  "The Empress": empressImage,
  "The Emperor": emperorImage,
  "The Hierophant": hierophantImage,
  "The Lovers": loversImage,
  "The Chariot": chariotImage,
  "Strength": strengthImage,
  "The Hermit": hermitImage,
  "The Wheel of Fortune": wheelOfFortuneImage,
  "Justice": justiceImage,
  "The Hanged Man": hangedManImage,
  "Death": deathImage,
  "Temperance": temperanceImage,
  "The Devil": devilImage,
  "The Tower": towerImage,
  "The Star": starImage,
  "The Moon": moonImage,
  "The Sun": sunImage,
  "Judgement": judgementImage,
  "The World": worldImage,
  "Two of Cups": twoOfCupsImage,
  "Three of Cups": threeOfCupsImage,
  "Four of Cups": fourOfCupsImage,
  "Five of Cups": fiveOfCupsImage,
  "Six of Cups": sixOfCupsImage,
  "Seven of Cups": sevenOfCupsImage,
  "Eight of Cups": eightOfCupsImage,
  "Nine of Cups": nineOfCupsImage,
  "Ten of Cups": tenOfCupsImage,
  "Ace of Cups": aceOfCupsImage,
  "King of Cups": kingOfCupsImage,
  "Knight of Cups": knightOfCupsImage,
  "Page of Cups": pageOfCupsImage,
  "Queen of Cups": queenOfCupsImage,
  "Two of Pentacles": twoOfPentaclesImage,
  "Three of Pentacles": threeOfPentaclesImage,
  "Four of Pentacles": fourOfPentaclesImage,
  "Five of Pentacles": fiveOfPentaclesImage,
  "Six of Pentacles": sixOfPentaclesImage,
  "Seven of Pentacles": sevenOfPentaclesImage,
  "Eight of Pentacles": eightOfPentaclesImage,
  "Nine of Pentacles": nineOfPentaclesImage,
  "Ten of Pentacles": tenOfPentaclesImage,
  "Ace of Pentacles": aceOfPentaclesImage,
  "King of Pentacles": kingOfPentaclesImage,
  "Knight of Pentacles": knightOfPentaclesImage,
  "Page of Pentacles": pageOfPentaclesImage,
  "Queen of Pentacles": queenOfPentaclesImage,
  "Two of Swords": twoOfSwordsImage,
  "Three of Swords": threeOfSwordsImage,
  "Four of Swords": fourOfSwordsImage,
  "Five of Swords": fiveOfSwordsImage,
  "Six of Swords": sixOfSwordsImage,
  "Seven of Swords": sevenOfSwordsImage,
  "Eight of Swords": eightOfSwordsImage,
  "Nine of Swords": nineOfSwordsImage,
  "Ten of Swords": tenOfSwordsImage,
  "Ace of Swords": aceOfSwordsImage,
  "King of Swords": kingOfSwordsImage,
  "Knight of Swords": knightOfSwordsImage,
  "Page of Swords": pageOfSwordsImage,
  "Queen of Swords": queenOfSwordsImage,
  "Two of Wands": twoOfWandsImage,
  "Three of Wands": threeOfWandsImage,
  "Four of Wands": fourOfWandsImage,
  "Five of Wands": fiveOfWandsImage,
  "Six of Wands": sixOfWandsImage,
  "Seven of Wands": sevenOfWandsImage,
  "Eight of Wands": eightOfWandsImage,
  "Nine of Wands": nineOfWandsImage,
  "Ten of Wands": tenOfWandsImage,
  "Ace of Wands": aceOfWandsImage,
  "King of Wands": kingOfWandsImage,
  "Knight of Wands": knightOfWandsImage,
  "Page of Wands": pageOfWandsImage,
  "Queen of Wands": queenOfWandsImage,
};









// Data zodiak
const zodiakData = [
  { name: 'Aries', dateRange: 'March 21 - April 19', icon: ariesImage, element: 'Fire', description: 'Aries is a passionate, courageous, and energetic zodiac sign.' },
{ name: 'Taurus', dateRange: 'April 20 - May 20', icon: taurusImage, element: 'Earth', description: 'Taurus is practical, stable, and has a strong connection to the material world.' },
{ name: 'Gemini', dateRange: 'May 21 - June 20', icon: geminiImage, element: 'Air', description: 'Gemini is communicative, curious, and tends to think quickly.' },
{ name: 'Cancer', dateRange: 'June 21 - July 22', icon: cancerImage, element: 'Air', description: 'Cancer is emotional, intuitive, and cares deeply about family and home.' },
{ name: 'Leo', dateRange: 'July 23 - August 22', icon: leoImage, element: 'Fire', description: 'Leos are known as natural leaders, confident, and passionate.' },
{ name: 'Virgo', dateRange: 'August 23 - September 22', icon: virgoImage, element: 'Earth', description: 'Virgos tend to be analytical, detail-oriented, and methodical.' },
{ name: 'Libra', dateRange: 'September 23 - October 22', icon: libraImage, element: 'Air', description: 'Libras value fairness, balance, and social relationships.' },
{ name: 'Scorpio', dateRange: 'October 23 - November 21', icon: scorpioImage, element: 'Air', description: 'Scorpios are intense, mysterious, and have the ability to understand emotional depths.' },
{ name: 'Sagittarius', dateRange: 'November 22 - December 21', icon: sagittariusImage, element: 'Fire', description: 'Sagittarius is adventurous, optimistic, and loves freedom.' },
{ name: 'Capricorn', dateRange: 'December 22 - January 19', icon: capricornImage, element: 'Earth', description: 'Capricorns are known to be hardworking, ambitious, and organized.' },
{ name: 'Aquarius', dateRange: 'January 20 - February 18', icon: aquariusImage, element: 'Air', description: 'Aquarius is innovative, idealistic, and often thinks outside the box.' },
{ name: 'Pisces', dateRange: 'February 19 - March 20', icon: piscesImage, element: 'Air', description: 'Pisces are empathetic, creative, and tend to have a deep spiritual understanding.' },
];

const ZodiacHealthAndWellness = () => {
  const [selectedZodiac, setSelectedZodiac] = useState('');
  const [tarotCard, setTarotCard] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null); // State for selected date
  const [name, setName] = useState(''); // State for user name
  const [submitted, setSubmitted] = useState(false); // State for handling form submission
  const [success, setSuccess] = useState(false); // State for success message
  const [dateSelected, setDateSelected] = useState(false); // State for handling date selection
  const [showCalendar, setShowCalendar] = useState(false); // State to show calendar again

  const handleZodiacChange = (event) => {
    setSelectedZodiac(event.target.value);
  };

  const handleDateChange = (date) => {
    if (date <= new Date()) {
      setSelectedDate(date);
      setDateSelected(true); // Mark date as selected
    }
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleSubmit = () => {
    if (name && selectedZodiac) {
      setSuccess(true);
      setSubmitted(true);
      setDateSelected(false); // Reset date selection state
      setShowCalendar(false); // Hide calendar after submission
    }
  };

  const handleRefresh = () => {
    if (selectedDate && selectedZodiac) {
      // Fetch a new random tarot card
      axios.get('https://tarotapi.dev/api/v1/cards/random?n=1')
        .then(response => {
          setTarotCard(response.data.cards[0]);
        })
        .catch(error => {
          console.error('Error fetching tarot card:', error);
        });
    }
  };

  const handleNewDate = () => {
    setShowCalendar(true); // Show calendar to select a new date
    setTarotCard(null); // Clear the current tarot card
  };

  const zodiacInfo = zodiakData.find(z => z.name === selectedZodiac);

  useEffect(() => {
    if (submitted && dateSelected && selectedDate && selectedZodiac) {
      // Fetch a random tarot card for the selected date
      axios.get('https://tarotapi.dev/api/v1/cards/random?n=1')
        .then(response => {
          setTarotCard(response.data.cards[0]);
        })
        .catch(error => {
          console.error('Error fetching tarot card:', error);
        });
    }
  }, [submitted, dateSelected, selectedDate, selectedZodiac]);

  return (
    <Container>
      <Typography variant="h4" align="center" gutterBottom>Start your day with inspiration and guidance through a daily card reading. Choose a card that will provide insight into a theme or feeling you may be dealing with today.</Typography>

      <FormControl fullWidth margin="normal">
        <InputLabel>Select Your Zodiac Sign</InputLabel>
        <Select
          value={selectedZodiac}
          onChange={handleZodiacChange}
          renderValue={(value) => {
            const selected = zodiakData.find(zodiac => zodiac.name === value);
            return (
              <Box display="flex" alignItems="center">
                <Avatar src={selected.icon} alt={selected.name} sx={{ width: 32, height: 32, marginRight: 1 }} />
                <Typography>{selected.name}</Typography>
              </Box>
            );
          }}
        >
          {zodiakData.map((zodiac) => (
            <MenuItem key={zodiac.name} value={zodiac.name}>
              <Box display="flex" alignItems="center">
                <Avatar src={zodiac.icon} alt={zodiac.name} sx={{ width: 32, height: 32, marginRight: 1 }} />
                <Typography>{zodiac.name}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        fullWidth
        margin="normal"
        label="Enter Your Name"
        variant="outlined"
        value={name}
        onChange={handleNameChange}
      />

      <Button
        variant="contained"
        color="success"
        onClick={handleSubmit}
        disabled={submitted} // Disable button if already submitted
      >
        Submit
      </Button>

      {success && (
        <Typography variant="h6" color="success.main" align="center" gutterBottom>
          Submission Successful!
        </Typography>
      )}

      {submitted && !dateSelected && (
        <Box my={4} className="calendar">
          <Typography variant="h6" align="center">Select a Date for Tarot Reading</Typography>
          <Calendar
            onChange={handleDateChange}
            value={selectedDate || new Date()} // Default to current date if none selected
            maxDate={new Date()} // Disable future dates
            tileDisabled={({ date }) => date > new Date()} // Disable future dates
          />
        </Box>
      )}

      {showCalendar && !tarotCard && (
        <Box my={4} className="calendar">
          <Typography variant="h6" align="center">Select a Date for Tarot Reading</Typography>
          <Calendar
            onChange={handleDateChange}
            value={selectedDate || new Date()} // Default to current date if none selected
            maxDate={new Date()} // Disable future dates
            tileDisabled={({ date }) => date > new Date()} // Disable future dates
          />
        </Box>
      )}

      {zodiacInfo && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Card sx={{ padding: 2, marginTop: 3, borderRadius: 2, boxShadow: 3 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={4}>
                <Avatar 
                  src={zodiacInfo.icon} 
                  alt={zodiacInfo.name} 
                  sx={{ width: 120, height: 120, margin: 'auto' }}
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <Typography variant="h5" gutterBottom>{zodiacInfo.name} ({zodiacInfo.dateRange})</Typography>
                <Typography variant="body1" gutterBottom>Element: {zodiacInfo.element}</Typography>
                <Typography variant="body2">
                  {zodiacInfo.description}
                </Typography>
              </Grid>
            </Grid>
          </Card>
        </motion.div>
      )}

{tarotCard && (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5 }}
    style={{ marginTop: 30 }}
  >
    <Card 
      sx={{ 
        padding: 2, 
        textAlign: 'center', 
        borderRadius: 2, 
        boxShadow: 3,
        border: '1px solid black' // Menambahkan bingkai bold hitam
      }}
    >
      <Typography variant="h5" gutterBottom>Tarot Card Reading for {name}</Typography>
      <Typography variant="h6" style={{ marginTop: 10 }}>{tarotCard.name}</Typography>
      <Box mt={2}>
        <Avatar 
          src={tarotImages[tarotCard.name] || 'https://via.placeholder.com/120x180.png?text=Image+Not+Available'} 
          alt={tarotCard.name} 
          sx={{ 
            width: 120, 
            height: 180, 
            margin: 'auto', 
            border: '1px solid #ddd', 
            borderRadius: 2 
          }}
        />
      </Box>
      <Typography variant="body2" style={{ marginTop: 10 }}>
        {tarotCard.meaning_up || 'No upright meaning available'}
      </Typography>
      <Typography variant="body2">
        {tarotCard.meaning_rev || 'No reversed meaning available'}
      </Typography>
      <Button
        variant="outlined"
        color="primary"
        onClick={handleRefresh}
        sx={{ marginTop: 2 }}
      >
        New Card
      </Button>
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleNewDate}
        sx={{ marginTop: 2, marginLeft: 2 }}
      >
        Choose New Date
      </Button>
    </Card>
  </motion.div>
)}
    </Container>
  );
};

export default ZodiacHealthAndWellness;
